<template>
  <div
    class="container"
    :style="`transform: translate(${x}px, ${y}px) scale(${scale});`"
  >
    <div
      class="animal"
      v-html="image.animal[playing ? `${animal}Sound` : animal]"
    />
    <div
      v-if="hat"
      class="hat"
      v-html="image.hat[hat.key]"
      :style="`left: ${hatPosition.x * 100}%; top: ${hatPosition.y * 100}%; width: ${hat.width * 100}%;`"
    />
  </div>
</template>

<script>
import { HATS } from 'constants';
import getAnimalObject from 'lib/getAnimalObject';
import audioPlayer from 'lib/audioPlayer';

import cow from 'assets/image/cow.svg';
import cowSound from 'assets/image/cow-sound.svg';
import fox from 'assets/image/fox.svg';
import foxSound from 'assets/image/fox-sound.svg';
import goat from 'assets/image/goat.svg';
import goatSound from 'assets/image/goat-sound.svg';

import halloween from 'assets/image/hat/halloween.svg';
import christmas from 'assets/image/hat/christmas.svg';
import newYear from 'assets/image/hat/new-year.svg';

export default {
  props: {
    animal: String,
    initialX: Number,
    initialY: Number,
  },
  computed: {
    hatPosition() { return getAnimalObject(this.animal).hatPosition; },
  },
  created() {
    const animal = getAnimalObject(this.animal);
    setTimeout(this.moveToCenter, 100);
    setTimeout(this.playSound, animal.winSoundDelay);
    setTimeout(this.endSound, 1400);
    setTimeout(this.complete, 2400);
  },
  data() {
    return {
      x: this.initialX,
      y: this.initialY,
      scale: 0.25,
      playing: false,
      hat: HATS.filter(h => h.test())[0],
      image: {
        animal: {
          cow,
          cowSound,
          fox,
          foxSound,
          goat,
          goatSound,
        },
        hat: {
          halloween,
          christmas,
          newYear,
        },
      },
    };
  },
  methods: {
    moveToCenter() {
      this.x = document.documentElement.offsetWidth / 2;
      this.y = document.documentElement.offsetHeight / 2;
      this.scale = 1;
    },
    playSound() {
      this.playing = true;
      audioPlayer.play(this.animal, 'win');
    },
    endSound() {
      this.playing = false;
    },
    complete() {
      this.$emit('complete');
    },
  },
};
</script>

<style lang="scss" scoped>
  $ratio: 1384 / 1024;

  .container {
    $size: 320px;

    height: $size / $ratio;
    left: 0;
    margin-left: -0.5 * $size;
    margin-top: -0.5 * $size / $ratio;
    position: absolute;
    top: 0;
    transition: transform 0.5s;
    width: $size;

    .hat {
      position: absolute;
      transform: translate(-50%, -50%);
    }
  }
</style>



// WEBPACK FOOTER //
// Animal.vue?08a5fb6a